import { Controller } from "stimulus";

// Removes the closest ".nested-form-wrapper" ancestor from the DOM on
// click. Used for plain array-of-hashes form sections (e.g. WeployCv
// parsed_data, a JSONB column, not an ActiveRecord association) where
// there's no accepts_nested_attributes_for/_destroy convention to hook
// into — simply dropping the fields from the DOM before submit is enough
// to drop that entry from the saved array. Deliberately NOT reusing
// stimulus-rails-nested-form's own remove() for this: that one assumes a
// `_destroy` hidden field exists inside the wrapper (Rails nested-
// attributes convention) and throws when it doesn't, which is exactly
// what happens for every existing, page-load-rendered entry here.
export default class extends Controller {
  remove(event: Event) {
    event.preventDefault();
    (event.target as HTMLElement).closest(".nested-form-wrapper")?.remove();
  }
}
